import fetch from '@api/fetchers';

export const getPaymentMethods = ({
  subscriptionUID,
  referralCode = '',
  useCredits = false,
  isPartPaymentFlow = false,
  noOfInstalments = 1
}) =>
  fetch('v1/payments/methods/all/', {
    params: {
      subscription_uid: subscriptionUID,
      user_subscription_status: 0,
      referral_code: referralCode,
      use_credits: useCredits,
      is_part_payment_flow: isPartPaymentFlow,
      fetch_only_part_payment_methods: isPartPaymentFlow,
      no_of_installments: noOfInstalments
    }
  });

export const getLoanEmiPlans = ({ amount, phone }) => {
  const totalAmt = Math.round(amount);
  return fetch('v1/payments/loan/emi_plans/', {
    params: {
      amount: totalAmt,
      phone
    }
  });
};

export const submitLoanRequest = (body) =>
  fetch('v1/subscriptions/user_loan_request/create/', {
    requestType: 'POST',
    body
  });

export const getBankAliasesEndpoint = () => 'api/card-brands-to-banks';

export const getSavedCardsEndpoint = () => 'v1/payments/juspay/cards/';

export const getPartPaymentsFaqEndpoint = () =>
  'v1/subscriptions/part_payment_faq';

export const getPartPaymentsInfoEndpoint = () => 'part-payments-infos';

export const verifyDCEMIEligibility = ({ phoneNo, bankId, amount }) =>
  fetch(
    `v1/payments/dc_emi/eligibility/?phone=${phoneNo}&bank=${bankId}&amount=${amount}`,
    { useCamelCase: false }
  );

export const validateVPA = (upiId) =>
  fetch('v1/payments/juspay/verify_vpa/', {
    requestType: 'POST',
    body: {
      vpa: upiId
    }
  });

export const cancelCashPayment = (orderId) =>
  fetch('v1/payments/isure/cancel/', {
    requestType: 'POST',
    body: {
      order_id: orderId,
      gateway: 8
    }
  });

export const enrollJuspayOrder = (subscriptionId, body, headers = {}) =>
  fetch(`v1/subscriptions/order/${subscriptionId}/`, {
    requestType: 'POST',
    body,
    headers
  });

export const enrollJuspayInstalmentOrder = (
  subscriptionId,
  orderUid,
  body,
  headers = {}
) =>
  fetch(`v1/subscriptions/order/${subscriptionId}/${orderUid}/`, {
    requestType: 'POST',
    body,
    headers
  });
